import {
    Box,
    Skeleton,
    SxProps,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from "@mui/material";

type TSkeletonList = {
    mkey: string;
    cols?: number;
    rows?: number;
    rowsForCell?: number;
    hasLabel?: boolean;
    hasHeader?: boolean;
    iconCols?: number;
    useIcons?: boolean;
    hasIconBefore?: boolean;
    sx?: SxProps;
};

const SkeletonList = (props: TSkeletonList) => {
    const {
        mkey = "fake_item_list_" + props.mkey,

        cols = props.cols ?? 1,
        rows = props.rows ?? 6,
        rowsForCell = props.rowsForCell ?? 2,
        hasLabel = props.hasLabel ?? false,
        hasHeader = props.hasHeader ?? false,

        iconCols = props.iconCols ?? 3,
        useIcons = props.useIcons ?? false,

        hasIconBefore = props.hasIconBefore ?? false,
    } = props;

    return (
        <Table key={mkey} sx={props.sx} className="skeleton">
            {hasHeader && (
                <TableHead>
                    <TableRow>
                        {/* Icona prima */}
                        {hasIconBefore && (
                            <TableCell width={20}>
                                <Skeleton variant="rectangular" width={20} />
                            </TableCell>
                        )}

                        {/* Mostrare gli header */}
                        {Array(cols)
                            .fill(1)
                            .map((_, index) => (
                                <TableCell key={`${mkey}_${index}`}>
                                    <Skeleton
                                        variant="text"
                                        width={
                                            Math.floor(
                                                Math.random() * 50 + 15
                                            ) + "%"
                                        }
                                    />
                                </TableCell>
                            ))}

                        {/* Mostra gli header delle icone */}
                        {useIcons &&
                            Array(iconCols)
                                .fill(1)
                                .map((_, index) => (
                                    <TableCell
                                        width={20}
                                        key={`${mkey}_${index}`}
                                    >
                                        <Skeleton
                                            variant="rectangular"
                                            width={20}
                                        />
                                    </TableCell>
                                ))}
                    </TableRow>
                </TableHead>
            )}

            {/* Body */}
            <TableBody>
                {Array(rows)
                    .fill(1)
                    .map((_, rowIndex) => (
                        <TableRow key={`${mkey}_${rowIndex}`}>
                            {hasIconBefore && (
                                <TableCell width={20}>
                                    <Skeleton
                                        variant="rectangular"
                                        width={20}
                                    />
                                </TableCell>
                            )}

                            {/* Mostra le righe */}
                            {Array(cols)
                                .fill(1)
                                .map((_, colIndex) => (
                                    <TableCell key={`${mkey}_${rowIndex}_${colIndex}`}>
                                        {Array(rowsForCell)
                                            .fill(1)
                                            .map((_, rowsForCellIndex) => (
                                                <Box key={`${mkey}_${rowIndex}_${colIndex}_${rowsForCellIndex}`}
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        gap: 2,
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    {hasLabel && (
                                                        <Skeleton
                                                            variant="rectangular"
                                                            key={`${mkey}_${rowIndex}_${colIndex}_${rowsForCellIndex}_Label`}
                                                            width={"35%"}
                                                            height={30}
                                                        />
                                                    )}
                                                    <Skeleton
                                                        variant="text"
                                                        key={rowsForCellIndex}
                                                        width={
                                                            Math.floor(
                                                                Math.random() *
                                                                    (hasLabel
                                                                        ? 25
                                                                        : 50) +
                                                                    15
                                                            ) + "%"
                                                        }
                                                        height={20}
                                                    />
                                                </Box>
                                            ))}
                                    </TableCell>
                                ))}

                            {/* Mostra le icone */}
                            {useIcons &&
                                Array(iconCols)
                                    .fill(1)
                                    .map((_, colIndex) => (
                                        <TableCell
                                            width={20}
                                            key={`${mkey}_${rowIndex}_${colIndex}_Icon`}
                                        >
                                            <Skeleton
                                                variant="rectangular"
                                                width={20}
                                            />
                                        </TableCell>
                                    ))}
                        </TableRow>
                    ))}
            </TableBody>
        </Table>
    );
};

export default SkeletonList;
